var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTopupLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10V4.5C14 3.67157 13.3284 3 12.5 3C11.6716 3 11 3.67157 11 4.5V10H5.5C4.67157 10 4 10.6716 4 11.5C4 12.3284 4.67157 13 5.5 13H11V18.5C11 19.3284 11.6716 20 12.5 20C13.3284 20 14 19.3284 14 18.5V13H19.5C20.3284 13 21 12.3284 21 11.5C21 10.6716 20.3284 10 19.5 10H14Z",
    fill: "#482701"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_108_7477",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10V4.5C14 3.67157 13.3284 3 12.5 3C11.6716 3 11 3.67157 11 4.5V10H5.5C4.67157 10 4 10.6716 4 11.5C4 12.3284 4.67157 13 5.5 13H11V18.5C11 19.3284 11.6716 20 12.5 20C13.3284 20 14 19.3284 14 18.5V13H19.5C20.3284 13 21 12.3284 21 11.5C21 10.6716 20.3284 10 19.5 10H14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_108_7477)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopupLight);
export default __webpack_public_path__ + "static/media/icon_topup_light.dff37f0f32291c218cd88ba19f9b8ccb.svg";
export { ForwardRef as ReactComponent };